module.exports = __webpack_public_path__ + "img/landing_top.b088e18c.png";